module.exports = __webpack_public_path__ + "static/media/majorE6.6d3d44c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE6.wav
// module id = T5W5
// module chunks = 0